module.exports = __webpack_public_path__ + "img/cover-promotion-bg.deb85f8d.png";